<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 6C12.552 6 13 5.553 13 5V3C13 2.447 12.552 2 12 2C11.448 2 11 2.447 11 3V5C11 5.553 11.448 6 12 6ZM12 14C10.897 14 10 13.103 10 12C10 10.897 10.897 10 12 10C13.103 10 14 10.897 14 12C14 13.103 13.103 14 12 14ZM12 8C9.794 8 8 9.794 8 12C8 14.206 9.794 16 12 16C14.206 16 16 14.206 16 12C16 9.794 14.206 8 12 8ZM19 11H21C21.552 11 22 11.447 22 12C22 12.553 21.552 13 21 13H19C18.448 13 18 12.553 18 12C18 11.447 18.448 11 19 11ZM6 12C6 11.447 5.552 11 5 11H3C2.448 11 2 11.447 2 12C2 12.553 2.448 13 3 13H5C5.552 13 6 12.553 6 12ZM4.80641 5.05284C5.19041 4.65684 5.82341 4.64484 6.22041 5.02784L7.65941 6.41784C8.05641 6.80084 8.06741 7.43484 7.68341 7.83184C7.48741 8.03484 7.22641 8.13684 6.96441 8.13684C6.71441 8.13684 6.46441 8.04484 6.26941 7.85684L4.83041 6.46684C4.43341 6.08384 4.42241 5.44984 4.80641 5.05284ZM17.0352 8.13684C17.2852 8.13684 17.5352 8.04384 17.7302 7.85684L19.1692 6.46684C19.5662 6.08284 19.5772 5.44884 19.1932 5.05284C18.8102 4.65684 18.1782 4.64484 17.7792 5.02784L16.3402 6.41684C15.9432 6.80084 15.9322 7.43484 16.3162 7.83084C16.5122 8.03384 16.7732 8.13684 17.0352 8.13684ZM11 19C11 18.447 11.448 18 12 18C12.552 18 13 18.447 13 19V21C13 21.553 12.552 22 12 22C11.448 22 11 21.553 11 21V19ZM17.7302 16.1431C17.3332 15.7601 16.7002 15.7721 16.3162 16.1681C15.9322 16.5651 15.9432 17.1991 16.3402 17.5821L17.7792 18.9721C17.9742 19.1601 18.2242 19.2521 18.4742 19.2521C18.7362 19.2521 18.9972 19.1501 19.1932 18.9471C19.5772 18.5501 19.5662 17.9161 19.1692 17.5331L17.7302 16.1431ZM4.83041 17.5331L6.26941 16.1431C6.66741 15.7601 7.30041 15.7721 7.68341 16.1681C8.06741 16.5651 8.05641 17.1991 7.65941 17.5821L6.22041 18.9721C6.02541 19.1601 5.77541 19.2521 5.52541 19.2521C5.26341 19.2521 5.00241 19.1501 4.80641 18.9471C4.42241 18.5501 4.43341 17.9161 4.83041 17.5331Z"
      :fill="color"
    />
  </svg>
</template>
<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  props: {
    color: {
      type: String,
      default: "white",
    },
  },
})
</script>
